<template>
  <v-autocomplete
    v-model="category"
    :dense="$vuetify.breakpoint.xsOnly"
    :items="richCategories"
    clearable
    item-text="nameTextLabel"
    item-value="id"
    outlined return-object v-bind="$attrs">
    <template v-slot:item="{parent, item, on, attrs}">
      <v-list-item class="" dense v-bind="attrs"
                   v-on="on">
        <v-list-item-content>
          <v-list-item-subtitle>
            {{ item.nameTextLabel }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-list-item-action-text>
            <div v-if="item.type" class="d-md-flex justify-md-end">
              <template v-for="t in item.type">
                <v-chip :key="t" x-small>
                  {{ $categoryTypes.find(ct => ct.value === t).text }}
                </v-chip>
              </template>
            </div>
          </v-list-item-action-text>

        </v-list-item-action>

      </v-list-item>
    </template>
    <template v-slot:selection="{parent, item, on, attrs}">
      <div class="d-md-flex justify-md-space-between align-center py-2" v-bind="attrs" v-on="on">
        <div class="">{{ item.nameTextLabel }}</div>
        <div v-if="item.type" class="d-md-flex justify-md-end">
          <template v-for="t in item.type">
            <v-chip :key="t" x-small>
              {{ $categoryTypes.find(ct => ct.value === t).text }}
            </v-chip>
          </template>
        </div>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import categoryService from "@/service/category.service";
/*:label="$t('tasks_management.task_category')"*/
export default {
  name: "CategorySelect",
  props: {
    value: {
      type: [Number, Object],
      default: null,
    },
  },
  data() {
    let value = this.value;
    if (!('returnObject' in this.$attrs || 'return-object' in this.$attrs)) {
      value = {id: this.value};
    }
    return {
      category: value,
    }
  },
  watch: {
    value(value) {
      if (!('returnObject' in this.$attrs || 'return-object' in this.$attrs)) {
        value = {id: this.value};
      }
      this.category = value;
    },
    category(category) {
      if (category && ('returnObject' in this.$attrs || 'return-object' in this.$attrs)) {
        this.$emit('input', category);
      } else if (category) {
        this.$emit('input', category.id);
      } else {
        this.$emit('input', null);
      }
    },
  },
  computed: {
    richCategories() {
      let categories = [...categoryService.richAllCategories];
      categories = categories.flatMap(category => [category, ...(category.level === 1 ? category?.children : [])]);
      categories.forEach(c => {
        c.nameTextLabel = [c.nameText, c?.parentCategory?.nameText, c?.parentCategory?.parentCategory?.nameText]
          .reverse()
          .filter(Boolean)
          .join(' > ');
      });
      return categories;
    },
  }
}
</script>

<style scoped>

</style>
